import { DialogProps } from '@material-ui/core/Dialog'

export function withDisableBackdropClick(func: DialogProps['onClose']): DialogProps['onClose'] {
  return (event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return
    }

    return func?.(event, reason)
  }
}
